var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"details-add-to-wishlist"},[_c('button',{staticClass:"details-add-to-wishlist-button uk-button uk-button-default cbx-border",class:_vm.cssClasses,attrs:{"type":"button"},on:{"click":_vm.toggleProduct}},[_c('span',{attrs:{"uk-icon":"icon: heart; ratio: 1.3;"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }